var PopUps;
(function (PopUps) {
    PopUps["Help"] = "Help";
    PopUps["Fairness"] = "Fairness";
    PopUps["CheckHash"] = "CheckHash";
    PopUps["SlowConnection"] = "SlowConnection";
    PopUps["Reconnect"] = "Reconnect";
    PopUps["ConnectionError"] = "ConnectionError";
    PopUps["Result"] = "Result";
    PopUps["MobileNavigation"] = "MobileNavigation";
    PopUps["GameOpen"] = "GameOpen";
})(PopUps || (PopUps = {}));

export { PopUps };
